import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { ChevronUp } from '@finect/tabular-icons/chevronUp';
import { ChevronDown } from '@finect/tabular-icons/chevronDown';
import { dataLayer } from '@finect/front-gtm';
import { ThTooltip } from '../ThTooltip';
import { NEXT_ORDER_TYPES, orderByIndex } from '../utils';
import { Th, LabelContent, ArrowsWrapper, ArrowContent } from '../partials';
export var ThCell = function ThCell(props) {
  var fistColumnAsHeader = props.fistColumnAsHeader,
    column = props.column,
    order = props.order,
    onOrderChange = props.onOrderChange,
    index = props.index;
  var tooltip = column.tooltip;
  var isOrderable = column.orderable && onOrderChange;
  var scopeProps = fistColumnAsHeader && index === 0 ? {
    scope: 'row'
  } : {};
  var thProps = _objectSpread(_objectSpread({}, column.params), scopeProps);
  var orderField = order ? order.field : null;
  var orderType = order ? order.type : 'none';
  var handleOrderAction = isOrderable ? function () {
    var orderParams = _objectSpread(_objectSpread({}, order), {
      field: column.uniqueId,
      type: NEXT_ORDER_TYPES[orderType]
    });
    onOrderChange && onOrderChange(orderParams);
    dataLayer({
      id: 'GenericTable',
      type: 'order',
      params: {
        orderParams: orderParams,
        column: column
      }
    });
  } : function () {};
  return React.createElement(Th, thProps, React.createElement(LabelContent, _extends({}, column.params, {
    onClick: handleOrderAction
  }), column.component, tooltip ? React.createElement(ThTooltip, {
    tooltip: tooltip
  }) : null, isOrderable ? React.createElement(ArrowsWrapper, null, React.createElement(ArrowContent, {
    active: orderField === column.uniqueId && orderType === 'asc'
  }, React.createElement(ChevronUp, {
    strokeWidth: "8px",
    size: "6px"
  })), React.createElement(ArrowContent, {
    active: orderField === column.uniqueId && orderType === 'desc'
  }, React.createElement(ChevronDown, {
    strokeWidth: "8px",
    size: "6px"
  }))) : null));
};